<dialog-draggable-header>Add Program Relationship for Part: {{this.part.partNumber}}</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="addProgramRelationForm">
    <div>
      <mat-form-field>
        <mat-label>Program:</mat-label>
        <mat-select formControlName="program">
          <mat-option *ngFor="let program of (programs$ | async)" [value]="program.id">
            {{program.programNameYear}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" (keypress.enter)="save()" (click)="save()">Save</button>
  <button mat-raised-button (keypress.enter)="close()" (click)="close()">Cancel</button>
</mat-dialog-actions>